import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  config: {},
};

const featureConfigSlice = createSlice({
  name: 'featureConfig',
  initialState,
  reducers: {
    updateFeatureConfig: (state, { payload }) => ({ ...state, config: payload }),
    reset: () => initialState,
  },
});

export const {
  reset: resetFeatureConfig, updateFeatureConfig,
} = featureConfigSlice.actions;

export default featureConfigSlice.reducer;
